export const roomNames = [
    { value: 'AN', text: 'Anbau (AN)' },
    { value: 'AR', text: 'Aufstellraum (AR)' },
    { value: 'BL', text: 'Brennstofflagerraum (BL)' },
    { value: 'BR', text: 'Betriebsraum/Werkstatt (BR)' },
    { value: 'BÜ', text: 'Büro/Arbeitszimmer (BÜ)' },
    { value: 'BZ', text: 'Badezimmer/Dusche (BZ)' },
    { value: 'DB', text: 'Dachboden/Speicherraum/Bodenraum (DB)' },
    { value: 'EZ', text: 'Esszimmer (EZ)' },
    { value: 'FL', text: 'Flur/Treppenhaus/Diele (FL)' },
    { value: 'GZ', text: 'Gästezimmer (GZ)' },
    { value: 'HA', text: 'Halle, Werk-, Industrie-, Logistik- oder Verkaufs- (HA)' },
    { value: 'HW', text: 'Hauswirtschaftsraum (HW)' },
    { value: 'JZ', text: 'Jugend-/ Kinderzimmer (JZ)' },
    { value: 'KR', text: 'Kellerraum (KR)' },
    { value: 'KÜ', text: 'Küche (KÜ)' },
    { value: 'LR', text: 'Lager- und Abstellraum (LR)' },
    { value: 'SZ', text: 'Schlafzimmer (SZ)' },
    { value: 'TR', text: 'Technikraum/Hausanschlussraum (TR)' },
    { value: 'VR', text: 'Verkaufsraum/Laden/Geschäft/Gastraum (VR)' },
    { value: 'WC', text: 'Toilette (WC)' },
    { value: 'WG', text: 'Wintergarten (WG)' },
    { value: 'WZ', text: 'Wohnzimmer (WZ)' },
    { value: 'R1', text: 'Raum 1 (R1)' },
    { value: 'R2', text: 'Raum 2 (R2)' },
    { value: 'R3', text: 'Raum 3 (R3)' }
]
